import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import ImagePicker from "../../imagepicker/ImagePicker";
import FieldLabel from "./FieldLabel";
import s from "../styles/ProductForm.module.scss";

export default function BrandCreateDialog({
                                              open,
                                              onClose,
                                              newBrandName,
                                              setNewBrandName,
                                              newBrandLogo,
                                              setNewBrandLogo,
                                              handleCreateBrand,
                                              toSingleKey,
                                          }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Новий бренд</DialogTitle>

            <DialogContent className={s.dialogContent}>
                <FieldLabel hint="Наприклад: Dasty, Cattos, Fincsi">Назва бренду</FieldLabel>
                <TextField
                    value={newBrandName}
                    onChange={(e) => setNewBrandName(e.target.value)}
                    fullWidth
                    placeholder="Введи назву"
                />

                <div className={s.spacer12} />

                <FieldLabel hint="Лого буде використовуватись в каталозі">Лого</FieldLabel>
                <ImagePicker
                    value={newBrandLogo ? [newBrandLogo] : []}
                    onChange={(updater) => {
                        // підтримуємо і масив, і функцію (як у ImagePicker)
                        if (typeof updater === "function") {
                            const arr = updater(newBrandLogo ? [newBrandLogo] : []);
                            setNewBrandLogo(toSingleKey(arr));
                        } else {
                            setNewBrandLogo(toSingleKey(updater));
                        }
                    }}
                    single
                    folder="brands"
                    libraryPrefix="brands"
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined" type="button">
                    Скасувати
                </Button>
                <Button variant="contained" onClick={handleCreateBrand} type="button">
                    Створити
                </Button>
            </DialogActions>
        </Dialog>
    );
}